// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge.badge-pill[data-v-b329ee54]{height:2rem;display:inline-flex;align-items:center}.building-block-item[data-v-b329ee54]{border-bottom:4px solid #c7d121}.f-con[data-v-b329ee54]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
